import { GetQueryVariables } from "api/apiFunctions";
import { getRequest } from "api/commonActions/get";
import { AxiosResponse } from "axios";
import { Requests } from "config/api";
import { QueryParamsProps } from "declarations/commonServices";
import {
  GetClicksProps,
  GetClicksReturnType,
  GetReportsProps,
  GetReportsReturnType,
} from "declarations/reportServices";

export const GetReports = async ({
  limit,
  offset,
  setLoading,
}: GetReportsProps): Promise<GetReportsReturnType> => {
  let queryParams: QueryParamsProps = GetQueryVariables({
    limit,
    offset,
  });

  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getReports,
      queryParams,
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const reports = response.data?.reports;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      reports,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetClicks = async ({
  limit,
  offset,
  setLoading,
}: GetClicksProps): Promise<GetClicksReturnType> => {
  let queryParams: QueryParamsProps = GetQueryVariables({
    limit,
    offset,
  });

  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getClicks,
      queryParams,
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const clicks = response.data?.carClicks;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      clicks,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};
